export const OpenFormTag = ({ type, value }: { type: 'warning'; value?: string }) =>
  value ? <span className={`of-openform-tag of-openform-tag-${type}`}>{value}</span> : null;
